import axios from 'axios'
import { BASE_URL } from './base-url'

var base = BASE_URL;

export default class DocumentService {

    /**
     * Get user profile.
     * 
     * @param {string} token 
     * @return {User}
     */
    getDocuments(token, params) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/documents',
                method: 'get',
                withCredentials: true,
headers: {                   'Authorization': token
                },
                params: {
                    ...params
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    downloadDocuments(token, filename) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/staticdocuments/' + filename,
                method: 'get',
                withCredentials: true,
headers: {                   'Authorization': token
                },
                responseType: "blob"
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    downloadDocuments2(token, filename) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + filename,
                method: 'get',
                withCredentials: true,
headers: {                   'Authorization': token
                },
                responseType: "blob"
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    postDocument(token, formData) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/documents',
                method: 'post',
                withCredentials: true,
headers: {                   'Authorization': token,
                    'Content-Type': 'multipart/form-data'

                },
                data: formData

            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    deleteDocument(token, uuid, client) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/documents/' + uuid,
                method: 'delete',
                withCredentials: true,
headers: {                   'Authorization': token,

                },
                data: {
                    client: client
                }

            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    sendMailBill(token, clientName, yearBill, monthBill, fileName )
    {
        var data = {
            year:yearBill,
            month:monthBill,
            client:clientName,
            fileName:fileName
        }
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/documents/mailBill',
                method: 'post',
                withCredentials: true,
headers: {                   'Authorization': token,
                    'Content-Type': 'application/json',
                },
                data:data

            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }
}